<script lang="ts">
	import type { LoaderType, Size } from '../types.js';
	import { cva, type VariantProps } from 'class-variance-authority';
	import { twMerge } from 'tailwind-merge';

	const loaderClasses = cva(['h-[1em]', 'w-[1em]', 'text-inherit', 'text-purple-600'], {
		variants: {
			type: {
				circle: ['animate-spin'],
				dots: ['flex', 'flex-row']
			},
			color: {
				default: 'text-inherit',
				error: 'text-red-600',
				info: 'text-blue-600',
				success: 'text-green-600',
				warn: 'text-yellow-600'
			},
			size: {
				xl: 'text-2xl',
				lg: 'text-xl',
				md: 'text-lg',
				sm: 'text-sm'
			}
		}
	});

	export let size: Size | undefined = undefined;
	export let type: LoaderType;
	export let color: VariantProps<typeof loaderClasses>['color'] = 'default';

	$: classes = twMerge(loaderClasses({ type, color, size, ...$$restProps }));
</script>

{#if type === 'circle'}
	<svg class={classes} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />

		<path
			d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
			fill="currentColor"
		/>
	</svg>
{:else if type === 'dots'}
	<div class={classes}>
		<div class="animate-bounce">.</div>
		<div class="animate-bounce" style="animation-delay: 100ms">.</div>
		<div class="animate-bounce" style="animation-delay: 200ms">.</div>
	</div>
{:else}
	<div class="whitespace-nowrap">
		No <code>type</code>
		specified!
	</div>
{/if}
